import '../styles/site.scss';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import {playMidiNotes, playMidiChord} from './Audio';

export {playMidiNotes, playMidiChord, prepareAudio} from './Audio';

window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }
gtag('js', new Date());
gtag('config', 'G-TXQ613FSL6');

async function initialize() {
    document.querySelectorAll('.collapse').forEach(element => new Collapse(element, {toggle: false}));
    document.querySelectorAll('.dropdown-toggle').forEach(element => new Dropdown(element));

    // Bind before asynchronous imports: audio unlock stays inside the user gesture.
    document.addEventListener('click', event => {
        const button = event.target.closest('[data-midi-notes]');
        if (!button) return;
        event.preventDefault();
        const notes = JSON.parse(button.dataset.midiNotes);
        if (button.dataset.playMode === 'chord') playMidiChord(notes);
        else playMidiNotes(notes);
    });

    const charts = document.querySelectorAll('[data-chart]');
    if (charts.length) {
        const {drawFretRange} = await import(/* webpackChunkName: "charts" */ './FretRange');
        charts.forEach(element => {
            const shape = JSON.parse(element.textContent);
            drawFretRange('#' + shape.id, shape, semitone => playMidiNotes([semitone + 40]));
        });
    }
    const noteGame = document.querySelector('[data-note-game]');
    if (noteGame) {
        const {drawNoteGame} = await import(/* webpackChunkName: "note-game" */ './NoteGame');
        drawNoteGame(noteGame, playMidiNotes);
    }
    const chordGame = document.getElementById('chord-game-data');
    if (chordGame) {
        const {drawChordGame} = await import(/* webpackChunkName: "chord-game" */ './ChordGame');
        drawChordGame(JSON.parse(chordGame.textContent));
    }
}

function start() {
    initialize().catch(error => console.error('Unable to initialize Guitar Charts', error));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
else start();
